import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { ApplicationInsights, SeverityLevel } from '@microsoft/applicationinsights-web';
import { environment } from '@env/environment';

@Injectable()
export class ApplicationInsightsService {
  private appInsights: ApplicationInsights;

  constructor(private _httpService: HttpService) {
    if (!environment.useStubs) {
      this._httpService.get<string>(environment.applicationInsightsKeyUrl).subscribe((key) => {
        this.appInsights = new ApplicationInsights({
          config: {
            instrumentationKey: key
          }
        });

        this.appInsights.loadAppInsights();

        const telemetryInitializer = (envelope) => {
          envelope.tags['ai.cloud.role'] = 'IPO.OLS';
        };
        this.appInsights.addTelemetryInitializer(telemetryInitializer);
      }, () => {
        this.appInsights = null;
      });
    }
  }

  logPageView(name?: string, url?: string) {
    if (!this.appInsights) {
      return;
    }

    try {
      this.appInsights.trackPageView({
        name: name,
        uri: url
      });
    } catch { }
  }

  logEvent(name: string, properties?: any) {
    if (!this.appInsights) {
      return;
    }

    try {
      this.appInsights.trackEvent({ name: name }, properties);
    } catch { }
  }

  logErrorWithMessage(message: string, name: string, severityLevel?: SeverityLevel) {
    const error = new Error(message);
    error.name = name;
    this.logError(error, severityLevel);
  }

  logError(error: Error, severityLevel?: SeverityLevel) {
    if (!this.appInsights) {
      return;
    }

    if (!severityLevel) {
      severityLevel = SeverityLevel.Error;
    }

    const customError = new Error();
    customError.message = error.message;
    customError.name = error.name;
    customError.stack = error.stack;

    try {
      this.appInsights.trackException({
        exception: customError,
        severityLevel: severityLevel
      });
    } catch { }
  }
}
